import { render, staticRenderFns } from "./batch-add-program-modal.vue?vue&type=template&id=50035f5e&scoped=true"
import script from "./batch-add-program-modal.vue?vue&type=script&lang=js"
export * from "./batch-add-program-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50035f5e",
  null
  
)

export default component.exports